import { Injectable } from '@angular/core';
import { Http, Response, URLSearchParams, BaseRequestOptions } from '@angular/http';
import { Observable } from 'rxjs/Rx';

import { Testentity } from './testentity.model';
import { DateUtils } from 'ng-jhipster';
@Injectable()
export class TestentityService {

    private resourceUrl = 'api/testentities';
    private resourceSearchUrl = 'api/_search/testentities';

    constructor(private http: Http, private dateUtils: DateUtils) { }

    create(testentity: Testentity): Observable<Testentity> {
        const copy: Testentity = Object.assign({}, testentity);
        copy.myZonedDateTime = this.dateUtils.toDate(testentity.myZonedDateTime);
        copy.myLocalDate = this.dateUtils
            .convertLocalDateToServer(testentity.myLocalDate);
        return this.http.post(this.resourceUrl, copy).map((res: Response) => {
            return res.json();
        });
    }

    update(testentity: Testentity): Observable<Testentity> {
        const copy: Testentity = Object.assign({}, testentity);

        copy.myZonedDateTime = this.dateUtils.toDate(testentity.myZonedDateTime);
        copy.myLocalDate = this.dateUtils
            .convertLocalDateToServer(testentity.myLocalDate);
        return this.http.put(this.resourceUrl, copy).map((res: Response) => {
            return res.json();
        });
    }

    find(id: number): Observable<Testentity> {
        return this.http.get(`${this.resourceUrl}/${id}`).map((res: Response) => {
            const jsonResponse = res.json();
            jsonResponse.myZonedDateTime = this.dateUtils
                .convertDateTimeFromServer(jsonResponse.myZonedDateTime);
            jsonResponse.myLocalDate = this.dateUtils
                .convertLocalDateFromServer(jsonResponse.myLocalDate);
            return jsonResponse;
        });
    }

    query(req?: any): Observable<Response> {
        const options = this.createRequestOption(req);
        return this.http.get(this.resourceUrl, options)
            .map((res: any) => this.convertResponse(res))
        ;
    }

    delete(id: number): Observable<Response> {
        return this.http.delete(`${this.resourceUrl}/${id}`);
    }

    search(req?: any): Observable<Response> {
        const options = this.createRequestOption(req);
        return this.http.get(this.resourceSearchUrl, options)
            .map((res: any) => this.convertResponse(res))
        ;
    }


    private convertResponse(res: any): any {
        const jsonResponse = res.json();
        for (let i = 0; i < jsonResponse.length; i++) {
            jsonResponse[i].myZonedDateTime = this.dateUtils
                .convertDateTimeFromServer(jsonResponse[i].myZonedDateTime);
            jsonResponse[i].myLocalDate = this.dateUtils
                .convertLocalDateFromServer(jsonResponse[i].myLocalDate);
        }
        res._body = jsonResponse;
        return res;
    }

    private createRequestOption(req?: any): BaseRequestOptions {
        const options: BaseRequestOptions = new BaseRequestOptions();
        if (req) {
            const params: URLSearchParams = new URLSearchParams();
            params.set('page', req.page);
            params.set('size', req.size);
            if (req.sort) {
                params.paramsMap.set('sort', req.sort);
            }
            params.set('query', req.query);

            options.search = params;
        }
        return options;
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/testentity/testentity.service.ts